function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTransfer = function SvgTransfer(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 15 15.2",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 9.6c-.3 0-.5-.2-.5-.5.1-1.9-1.3-3.5-3.2-3.6H6.4v2.2c0 .3-.2.5-.4.5-.1 0-.3 0-.4-.1L2.2 4.5c-.2-.2-.2-.5 0-.7L5.6.2c.2-.2.5-.2.6-.1s.1.2.1.4v2.2h3.8c2.9.2 5 2.6 4.9 5.4v1c0 .3-.2.5-.5.5m-5.9 5.1v-2.2H4.8C2 12.3-.1 9.9 0 7.1v-1c0-.3.2-.5.5-.5s.5.2.5.5C.8 8 2.3 9.6 4.2 9.7h4.5V7.5c-.1-.3.1-.5.3-.6.1 0 .3 0 .4.1l3.4 3.6c.1.1.1.2.1.4 0 .1-.1.3-.1.4L9.4 15c-.2.2-.5.2-.6 0-.1-.1-.2-.2-.2-.3",
    style: {
      fill: "#414a5f"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTransfer);
export default ForwardRef;